<template>
  <div></div>
</template>

<script>
import { setToken } from '@/utils/auth.js';
export default {
  data() {
    return {
      fullscreenLoading: false,
    };
  },
  created() {
    this.openFullScreen2();
    this.$store.state.token = this.$route.query.token;
    setToken(this.$route.query.token);
    store.commit('SET_TOKEN', this.$route.query.token);
    console.warn('this.$store', this.$store);
  },
  methods: {
    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      if (this.$store.state.token) {
        loading.close();
      }
      this.$router.push('/index');
    },
  },
};
</script>
